import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Lightweight head manager (no react-helmet dependency).
 * Sets title, meta description, canonical, OG, Twitter, JSON-LD on mount.
 */
export default function Seo({
  title,
  description,
  image,
  type = "website",
  jsonLd,
  noindex = false,
}) {
  const loc = useLocation();

  useEffect(() => {
    const origin = window.location.origin;
    const url = `${origin}${loc.pathname}${loc.search}`;
    const finalTitle = title || "Berdhill Rooms · Boutique stay in Sarandë, Albania";
    const finalDesc = description ||
      "Boutique rooms and apartments above the Ionian Sea in Sarandë, Albania. Sea-view balconies, walking distance to the seafront and Corfu ferry.";
    const finalImage = image || "https://images.unsplash.com/photo-1627245979767-a1a2bc1cc543?w=1600&q=85";

    document.title = finalTitle;

    setMeta("name", "description", finalDesc);
    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    setLink("canonical", url);

    setMeta("property", "og:title", finalTitle);
    setMeta("property", "og:description", finalDesc);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", finalImage);
    setMeta("property", "og:site_name", "Berdhill Rooms");

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", finalTitle);
    setMeta("name", "twitter:description", finalDesc);
    setMeta("name", "twitter:image", finalImage);

    const tagId = "seo-jsonld";
    document.getElementById(tagId)?.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = tagId;
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, image, type, jsonLd, noindex, loc.pathname, loc.search]);

  return null;
}

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}
